import React from 'react';
import { TextField, MenuItem, Grid } from '@mui/material';

const JobPreferences = ({ formData, setFormData }) => {
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Preferred Job Roles"
          name="preferredJobRoles"
          value={formData.preferredJobRoles || []}
          onChange={handleChange}
          select
          SelectProps={{ multiple: true }}
        >
          <MenuItem value="Finance Manager">Finance Manager</MenuItem>
          <MenuItem value="Tax Consultant">Tax Consultant</MenuItem>
          <MenuItem value="Risk Analyst">Risk Analyst</MenuItem>
          <MenuItem value="Investment Analyst">Investment Analyst</MenuItem>
          <MenuItem value="Credit Analyst">Credit Analyst</MenuItem>
          <MenuItem value="Actuary">Actuary</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Preferred Industries"
          name="preferredIndustries"
          value={formData.preferredIndustries || []}
          onChange={handleChange}
          select
          SelectProps={{ multiple: true }}
        >
          <MenuItem value="Banking">Banking</MenuItem>
          <MenuItem value="Investment">Investment</MenuItem>
          <MenuItem value="Insurance">Insurance</MenuItem>
          <MenuItem value="FinTech">FinTech</MenuItem>
          <MenuItem value="NBFC">NBFC</MenuItem>
          <MenuItem value="Big 4 Firms">Big 4 Firms</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Remote/Onsite Preference"
          name="remoteOnsitePreference"
          value={formData.remoteOnsitePreference || ''}
          onChange={handleChange}
          select
        >
          <MenuItem value="Remote">Remote</MenuItem>
          <MenuItem value="Hybrid">Hybrid</MenuItem>
          <MenuItem value="Onsite">Onsite</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Willing to Relocate?"
          name="willingToRelocate"
          value={formData.willingToRelocate || ''}
          onChange={handleChange}
          select
        >
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </TextField>
      </Grid>
    </Grid>
  );
};

export default JobPreferences;